import {
    boolean,
    literal,
    nullable,
    object,
    optional,
    string,
    union,
} from "superstruct";

const InstagramCustomSettingsSchema = object({
    storiesEnabled: optional(boolean()),
    filter: optional(union([literal("all"), literal("only_tagged")])),
    taggedChildPost: optional(boolean()),
    galleryTitle: optional(nullable(string())),
    highQualityEnabled: optional(boolean()),
    forceDisabledStories: optional(boolean()),
});

export default InstagramCustomSettingsSchema;
